export const toLocalNumberFormat = (fractionDigits = 0, { fixed } = {}) => (_ = 0) => new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: fixed ? fractionDigits : 0,
    maximumFractionDigits: fractionDigits,
}).format(Number(_) || 0);
//# sourceMappingURL=toLocalNumberFormat.js.map